import {Component, Input, OnInit, ViewChild} from "@angular/core";
import {cloneDeep} from "lodash";
import {Address, AttachmentItem} from "../../api/entity";
import {Country} from "../../../../../../../common/api";
import {CorporateAccountsService, FileDownloadService} from "../../api/service";
import {NgForm} from "@angular/forms";
import {isNullOrUndefined} from "util";
import {NewCorporateDetailsComponent} from "../../../+applications/new/detail/+details/corporate";
import {FileUploadModalComponent} from "../file.upload.modal/file.upload.modal.component";
import {AttachmentType} from "../../../../../../../clients/app/modules/+registration/api";
import {FileUtils} from "../../../../../../../common/utils";
import {ValueByKeyPipe} from "../../../../../core/pipes/value.by.key.pipe";

@Component({
    selector: 'tfl-profile-detail-official-business-location',
    template: require('./official-business-location.template.html'),
    providers: [ValueByKeyPipe]
})
export class OfficialBusinessLocationComponent implements OnInit {

    readonly PATTERN = '^[a-zA-Z\\s.\'-]*$';
    @Input("profileId") profileId: number;
    @Input("loading") loading: boolean = true;
    @Input("countries") countries: Country[] = [];

    @ViewChild("editForm") editForm: NgForm;
    @ViewChild("addressFiles") addressFilesModalComponent: FileUploadModalComponent;

    officialBusinessLocation: Address = null;
    originalOfficialBusinessLocation: Address = null;
    addressDocuments: string = "official-business-location-address-documents";
    isEdited: boolean = false;
    attachmentTypeAddress: AttachmentType = AttachmentType.BUSINESS_ADDRESS;
    companyCountries: Country[] = [];
    chosenTaxCountry: string;

    ngOnInit(): void {
        this.companyCountries = this.countries;
        this.chosenTaxCountry = this._valueByKeyPipe.transform(this.countries);
    }

    constructor(private _corporateAccountsService: CorporateAccountsService,
                private _fileDownloadService: FileDownloadService,
                private _valueByKeyPipe: ValueByKeyPipe) {
    }

    @Input("officialBusinessLocation")
    set setOfficialBusinessLocation(officialBusinessLocation: Address) {
        if (!isNullOrUndefined(officialBusinessLocation)) {
            this.officialBusinessLocation = officialBusinessLocation;
            this.originalOfficialBusinessLocation = cloneDeep(this.officialBusinessLocation);
        }
    }

    onChangeInputValue(event, fieldName) {
        this.officialBusinessLocation[fieldName] = event.target.value;
    }

    isAddressValid(): boolean {
        return NewCorporateDetailsComponent.isAddressValid(this.officialBusinessLocation);
    }

    onEdit() {
        this.isEdited = true;
    }

    onDiscard(): void {
        this.officialBusinessLocation = cloneDeep(this.originalOfficialBusinessLocation);
        this.isEdited = false;
    }

    onSave(): void {
        this._corporateAccountsService.updateOfficialBusinessLocation(this.profileId, this.officialBusinessLocation)
            .subscribe((officialBusinessLocation) => this.officialBusinessLocation = cloneDeep(officialBusinessLocation));
        this.isEdited = false;
    }

    uploadAddressFiles(): void {
        this.addressFilesModalComponent.show();
    }

    removeAddressFile(id): void {
        this.editForm.controls.address.markAsDirty();
        this.officialBusinessLocation.attachmentItems =
            this.officialBusinessLocation.attachmentItems.filter((doc) => id !== doc.id);
    }

    saveAddressFiles(files: AttachmentItem[]): void {
        this.editForm.controls.address.markAsDirty();
        files.filter(file => this.officialBusinessLocation.attachmentItems.findIndex(f => f.name == file.name) == -1)
            .forEach(file => this.officialBusinessLocation.attachmentItems.push(file));
    }

    downloadAddressAttachments() {
        let ids: string[] = [];
        const fileName = 'proof_of_address';
        this.officialBusinessLocation.attachmentItems.map(item => ids.push(item.id));
        this._fileDownloadService.downloadAttachmentsFile(ids, fileName)
            .subscribe((response) => {
                FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
            });
    }

    downloadFile(id: string) {
        this._fileDownloadService.downloadFile(id)
            .subscribe((response) => {
                FileUtils.saveFile(FileUtils.getFilename(response), response.blob());
            });
    }

    isAttachmentsValid(): boolean {
        return !isNullOrUndefined(this.officialBusinessLocation)
            && !isNullOrUndefined(this.officialBusinessLocation.attachmentItems)
            && this.officialBusinessLocation.attachmentItems.length != 0;
    }

    isSaveDisabled(): boolean {
        if (!isNullOrUndefined(this.officialBusinessLocation)) {
            return !(this.editForm.form.dirty || this.originalOfficialBusinessLocation.country != this.officialBusinessLocation.country)
                || !this.editForm.form.valid || !this.isAddressValid() || !this.isAttachmentsValid();
        }
    }

    onSearchCountry(companyCountry: string) {
        this.companyCountries = this.countries.filter(
            country => country.name.toLocaleLowerCase().search(companyCountry.toLocaleLowerCase()) !== -1);
    }


    onSelectCountry(companyCountry) {
        if (companyCountry) {
            this.officialBusinessLocation.country = companyCountry.id;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/official-business-location/official-business-location.component.ts